import { render, staticRenderFns } from "./ProyectoList.vue?vue&type=template&id=515480f4&scoped=true&"
import script from "./ProyectoList.vue?vue&type=script&lang=js&"
export * from "./ProyectoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515480f4",
  null
  
)

export default component.exports